import React from 'react';

import { flagStyles } from '../settings';

const SvgKI = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2784px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKI;
